

export class EmployeeGroupStatusInput implements IEmployeeGroupStatusInput {
    /** The auto-generated id of the employee group master */
    employeeGroupId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IEmployeeGroupStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeGroupId = _data["employeeGroupId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmployeeGroupStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeGroupId"] = this.employeeGroupId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IEmployeeGroupStatusInput {
    /** The auto-generated id of the employee group master */
    employeeGroupId: number;
    /** The updated status */
    status: number;
}

